import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface FieldSpec {
  key: string;
  label: string;
}
export interface DocSpec {
  type: string;
  label: string;
}
export interface ProfileCompletion {
  entity: 'dealer' | 'client';
  detailsComplete: boolean;
  documentsComplete: boolean;
  complete: boolean;
  status: 'complete' | 'incomplete_details' | 'incomplete_documents';
  missingFields: FieldSpec[];
  missingDocs: DocSpec[];
}

export interface ProfileDocument {
  id: number;
  docType: string;
  fileName: string;
  fileUrl: string;
}

export interface ProfilePayload {
  entity: 'dealer' | 'client';
  profile: Record<string, unknown> & { id: number; code: string; name: string };
  completion: ProfileCompletion;
  requiredFields: FieldSpec[];
  requiredDocs: DocSpec[];
  documents: ProfileDocument[];
}

export interface ProfileUpdateInput {
  gstNumber?: string;
  panNumber?: string;
  contactPerson?: string;
  mobile?: string;
  address?: string;
  regionId?: number | null;
  stateId?: number | null;
  bankAccountName?: string;
  bankAccountNumber?: string;
  bankIfsc?: string;
  legalName?: string;
}

export const profileApi = {
  async completion(): Promise<{ applicable: boolean; entity?: string; completion?: ProfileCompletion }> {
    return (await apiClient.get<ApiSuccess<{ applicable: boolean; entity?: string; completion?: ProfileCompletion }>>('/me/profile-completion')).data.data;
  },
  async get(): Promise<ProfilePayload> {
    return (await apiClient.get<ApiSuccess<ProfilePayload>>('/me/profile')).data.data;
  },
  async update(input: ProfileUpdateInput): Promise<ProfilePayload> {
    return (await apiClient.put<ApiSuccess<ProfilePayload>>('/me/profile', input)).data.data;
  },
  async addDocument(input: { docType: string; fileName: string; fileUrl: string }): Promise<ProfilePayload> {
    return (await apiClient.post<ApiSuccess<ProfilePayload>>('/me/profile/documents', input)).data.data;
  },
};
